export default "__VITE_ASSET__4c8805ae__"